"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promisifyEventEmitter = void 0;
function promisifyEventEmitter(event, result) {
    return new Promise((resolve, reject) => {
        event.on('end', () => resolve(result));
        event.on('error', reject);
    });
}
exports.promisifyEventEmitter = promisifyEventEmitter;
